const $ = jQuery;
export default class CountUp {
    constructor(options = null) {}

    init() {
        this.__countUp();
    }

    __countUp() {
        // Get all elements with the class "countUp"
        const counterElements = document.querySelectorAll(".countUp");

        // Create an Intersection Observer
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // If the element is in view, start counting up
                        startCounting(entry.target);
                        // Stop observing this element after it's in view
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.5 }
        ); // This waits until the element is 50% in view. Adjust threshold as required.

        // Loop through each counter element
        counterElements.forEach((counterElement) => {
            // Start observing each countUp element
            observer.observe(counterElement);
        });

        // Function to start counting for a specific element
        function startCounting(element) {
            // Access the target number from the data attribute of the element
            const targetNumber = parseInt(element.getAttribute("data-target"));

            // Set the interval for counting up
            const interval = 20; // milliseconds
            const duration = 2000; // milliseconds
            const steps = duration / interval;
            const stepValue = targetNumber / steps;

            let currentNumber = 0;

            // Function to update the counter
            function updateCounter() {
                currentNumber += stepValue;

                // Round to an integer to avoid floating-point issues
                const roundedNumber = Math.round(currentNumber);

                // Update the counter element
                element.textContent = roundedNumber;

                // Stop the interval when the target number is reached
                if (roundedNumber >= targetNumber) {
                    clearInterval(counterInterval);
                    element.textContent = targetNumber; // Ensure the final value is accurate
                }
            }

            // Start the interval for each counter element
            const counterInterval = setInterval(updateCounter, interval);
        }
    }
}
